export default "__VITE_ASSET__CiZfSJXI__"